
<ng-container *ngIf="loading">
    <div class="container-with-loading">
        <div class="loading-overlay">
            <mat-spinner></mat-spinner>
        </div>
    </div>
</ng-container>
  
<mat-card class="offer-card" appearance="outlined" [hidden]="loading">
    <!--mat-card-header>
        <mat-card-title>Pocision</mat-card-title>
	</mat-card-header-->
	<mat-card-content>

		<form class="form-container" (ngSubmit)="onSubmitPosition(benefitGroupForm)" #benefitGroupForm="ngForm" >

			<mat-card class="general-wf-card" appearance="outlined">
				<!--mat-card-header>
					<mat-card-title>{{title}}</mat-card-title>
				</mat-card-header-->
				<mat-card-content>
					<div id="container" class="formControl">
					
						<div class="control">
							<mat-form-field class="controlWidth">
								<mat-label>N&uacute;mero de Posici&oacute;n</mat-label>
								<input type="text" matInput name="position.positionNum" [(ngModel)]="position.positionNum">
								<mat-error>{{ violations['position.positionNum'] }}</mat-error>
							</mat-form-field>
						</div>
						<div class="control">
							<mat-form-field class="controlWidth">
								<mat-label>Descripci&oacute;n</mat-label>
								<input type="text" matInput name="position.description" [(ngModel)]="position.description">
								<mat-error>{{ violations['position.description'] }}</mat-error>
							</mat-form-field>
						</div>
						<div class="control">
							<mat-form-field class="controlWidth">
								<mat-label>Posici&oacute;n Padre</mat-label>
								<input type="text" matInput name="position.parentPositionNum" [(ngModel)]="position.parentPositionNum">
								<mat-error>{{ violations['position.parentPositionNum'] }}</mat-error>
							</mat-form-field>
						</div>
						<div class="control">
							<mat-form-field class="controlWidth">
								<mat-label>Sueldo</mat-label>
								<input matInput type="text" name="position.baseSalary" [(ngModel)]="position.baseSalary" [appNumberFormat]="2" #salaryCtrl="ngModel">
								<mat-error>{{ violations['position.baseSalary'] }}</mat-error>
								<mat-error *ngIf="salaryCtrl.errors?.['invalidNumberFormat']">
								  Número inválido (máx. 2 decimales, usa ',' para miles)
								</mat-error>
							  </mat-form-field>
						</div>
						<div class="control">
							<mat-form-field class="controlWidth">
								<mat-label>Nivel</mat-label>
								<input type="text" matInput name="position.level" [(ngModel)]="position.level">
								<mat-error>{{ violations['position.level'] }}</mat-error>
							</mat-form-field>
						</div>
						<div class="control">
							<mat-form-field class="controlWidth">
								<mat-label>Pago Posici&oacute;n</mat-label>
								<input type="text" matInput name="positionPay" [(ngModel)]="position.positionPay">
								<mat-error>{{ violations['position.positionPay'] }}</mat-error>
							</mat-form-field>
						</div>
						<div class="control">
							<mat-slide-toggle [(ngModel)]="position.active"  name="position.active" > 
							  {{ position.active? 'Posicion Activa':'Posicion Inactiva'}} 
							</mat-slide-toggle>
						</div>

					</div>
				</mat-card-content>
			</mat-card>
			<div class="formControl">
				<div class="control">
					<button mat-flat-button class="button buttonWidth">
					  {{(position.id > 0)? 'Actualizar': 'Guardar'}}
					</button>
				</div>
			</div>
		</form>
	</mat-card-content>
</mat-card>